import { useQuery } from '@tanstack/react-query';
import { Palette, Sparkles } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { apiClient } from '@/services/api';

export function ThemesPage() {
  const { data: themes = [] } = useQuery({
    queryKey: ['themes'],
    queryFn: () => apiClient.getThemes().then(r => r.data),
  });

  return (
    <div className="container-app py-8">
      <h1 className="text-3xl font-bold flex items-center gap-2"><Palette className="h-7 w-7" />Galeria de Temas</h1>
      <p className="text-muted-foreground mt-1">Visuais prontos para o seu segmento</p>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 mt-8">
        {themes.map((t: any) => {
          const cfg = typeof t.config === 'string' ? JSON.parse(t.config) : t.config;
          const colors = cfg.colors || {};
          return (
            <Card key={t.id} className="overflow-hidden hover:shadow-lg transition-all">
              <div
                className="h-32 grid place-items-center text-2xl font-bold"
                style={{ backgroundColor: colors.background, color: colors.primary }}
              >
                <div style={{ color: colors.primary }}>R$ 9,90</div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <div className="font-semibold">{t.name}</div>
                  {t.is_premium && <Badge variant="default"><Sparkles className="h-3 w-3" /> Pro</Badge>}
                </div>
                <div className="text-sm text-muted-foreground mt-1">{t.description}</div>
                <Badge variant="muted" className="mt-3">{t.segment}</Badge>
                <div className="flex gap-1 mt-3">
                  {[colors.primary, colors.secondary, colors.accent, colors.promo].filter(Boolean).map((c, i) => (
                    <div key={i} className="h-6 w-6 rounded-full border-2 border-white shadow" style={{ backgroundColor: c }} />
                  ))}
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
